import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * Breadcrumbs — semantic <nav> with visible chevron-separated links.
 * Pair this with `breadcrumbSchema(items)` from `@/lib/seo` to emit
 * BreadcrumbList JSON-LD for Google's rich result.
 *
 * Each item: { label: string, to?: string }   (last item should omit `to`)
 */
export const Breadcrumbs = ({ items = [], className = "" }) => {
  if (!items.length) return null;
  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
      className={`text-xs sm:text-sm text-foreground/70 ${className}`}
    >
      <ol className="flex flex-wrap items-center gap-1">
        <li className="inline-flex items-center">
          <Link to="/" className="inline-flex items-center gap-1 hover:text-primary" data-testid="breadcrumb-home">
            <Home className="w-3.5 h-3.5" /> Home
          </Link>
        </li>
        {items.map((it, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className="inline-flex items-center gap-1">
              <ChevronRight className="w-3.5 h-3.5 text-foreground/40" />
              {isLast || !it.to ? (
                <span className="text-foreground" aria-current="page">{it.label}</span>
              ) : (
                <Link to={it.to} className="hover:text-primary">{it.label}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
